import { render } from "./HeaderVideo.vue?vue&type=template&id=eb874662"
import script from "./HeaderVideo.vue?vue&type=script&lang=js"
export * from "./HeaderVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__